/**
 * @generated SignedSource<<1f83698e03e27f727ef1e2fe7252fc51>>
 * @relayHash 0c433cda5f667bcf4a540416173db6d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a2dff011be60f61ee521340c2f88a86124a936945911e4b5bfb138137a0954e0

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type list_RuleList_Query$variables = {
  cloudId: string;
  first: number;
  projectKey: string;
};
export type list_RuleList_Query$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly conditionalFormattingRules: {
        readonly __id: string;
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly expression: {
              readonly fieldId?: string;
            };
            readonly id: string;
            readonly " $fragmentSpreads": FragmentRefs<"ruleItem_businessConditionalFormattingSidebar">;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    };
  };
};
export type list_RuleList_Query = {
  response: list_RuleList_Query$data;
  variables: list_RuleList_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "list_RuleList_Query",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v3/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": [
                  {
                    "args": (v4/*: any*/),
                    "concreteType": "JiraFormattingRuleConnection",
                    "kind": "LinkedField",
                    "name": "conditionalFormattingRules",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraFormattingRuleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraFormattingRule",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "expression",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v7/*: any*/),
                                    "type": "JiraFormattingMultipleValueOperand"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v7/*: any*/),
                                    "type": "JiraFormattingSingleValueOperand"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v7/*: any*/),
                                    "type": "JiraFormattingNoValueOperand"
                                  }
                                ]
                              },
                              {
                                "kind": "FragmentSpread",
                                "name": "ruleItem_businessConditionalFormattingSidebar"
                              }
                            ]
                          }
                        ]
                      },
                      (v8/*: any*/)
                    ]
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.jiraProjectByKey"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "list_RuleList_Query",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "JiraFormattingRuleConnection",
                "kind": "LinkedField",
                "name": "conditionalFormattingRules",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFormattingRuleEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraFormattingRule",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "expression",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "__typename"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": "multipleValueOperator",
                                    "kind": "ScalarField",
                                    "name": "operator"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "values"
                                  }
                                ],
                                "type": "JiraFormattingMultipleValueOperand"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": "singleValueOperator",
                                    "kind": "ScalarField",
                                    "name": "operator"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "value"
                                  }
                                ],
                                "type": "JiraFormattingSingleValueOperand"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": "noValueOperator",
                                    "kind": "ScalarField",
                                    "name": "operator"
                                  }
                                ],
                                "type": "JiraFormattingNoValueOperand"
                              }
                            ]
                          },
                          {
                            "concreteType": "JiraColor",
                            "kind": "LinkedField",
                            "name": "formattingColor",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "colorKey"
                              },
                              (v5/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "formattingArea"
                          }
                        ]
                      }
                    ]
                  },
                  (v8/*: any*/)
                ]
              },
              (v5/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a2dff011be60f61ee521340c2f88a86124a936945911e4b5bfb138137a0954e0",
    "metadata": {},
    "name": "list_RuleList_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bec8fc4cc19c330e28e463dc69485d6f";

export default node;
